import { render, staticRenderFns } from "./ExpandableFullTextPanel.vue?vue&type=template&id=1b36ae0f&scoped=true&"
import script from "./ExpandableFullTextPanel.vue?vue&type=script&lang=js&"
export * from "./ExpandableFullTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableFullTextPanel.vue?vue&type=style&index=0&id=1b36ae0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36ae0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
